import React from 'react';
import loadable from '@loadable/component';
import PeyaLoader from '@pedidosya/web-fenix/animations/PeyaLoader';
import { Switch, Route } from 'react-router-dom';
/**
 * config
 */
import { Routes } from '@app/shared/config/routes';
/**
 * Pages
 */
const Orders = loadable(() => import('@app/orders/main/Orders'), {
  resolveComponent: (components) => components.Orders,
  fallback: <PeyaLoader position="center" />,
});
const NotFound = loadable(() => import('@app/shared/components/NotFound'), {
  resolveComponent: (components) => components.NotFound,
  fallback: <PeyaLoader position="center" />,
});

const RouterApp = () => {
  return (
    <Switch>
      <Route exact path={Routes.MY_ORDERS}>
        <Orders />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
};

export { RouterApp };
